import Context from "./GridContext";
import { useContext } from "react";

const useGridContext = () => useContext(Context);

export default useGridContext;
